import { useToast } from "contexts/ToastContext";
import { useEffect, useRef, useState } from "react";
import { LoadingPageIcon } from "utils/constant";
import { useTranslation } from "react-i18next";

import { useParams, useLocation } from "react-router-dom";
import { getStakeholder } from "services/getEmployees";
import LegislativeDraftDetail from "./fragments/leftPanel";
import { getLegislativeDrafting } from "services/legislativeService";
import LegislativeDraftRightPanel from "./fragments/rightPanel";
import { useAuth } from "contexts/AuthContext";
import RegistrarLegislativeDraft from "./registrarLegislativeDraft";
import { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";

import { getLegalAdvisories, getLegalAdvisory } from "services/legalAdvisoryService";
import LegalAdvisoryDetail from "./fragments/leftPanel";
import LegalAdvisoryRightPanel from "./fragments/rightPanel";
import { getSectorDirective, getSectorDirectives } from "services/sectorDirectives";
import { getLegalTranslation, getLegalTranslationInternal } from "services/legalTranslationService";
import RegistrarLegalTranslation from "./registrarLegalTranslation";

const SingleLegalTranslation = () => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [data, setData] = useState<any>({
        isLoading: true, status: "", forward_status: "", documents: [], request_summary: "", request_letter_reference_number: "", current_status: ""
    });
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const contextData = useAuth();
    const isInternalMode = location.pathname.includes('/legal-translation/internal');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = isInternalMode 
                    ? await getLegalTranslationInternal(id || "")
                    : await getLegalTranslation(id || "");
                let user = null;
                if (response.requested_by_id && response.requested_by !== "internal") {
                    try {
                        user = await getStakeholder(response.requested_by_id, contextData.token || contextData?.user?.access_token || "");
                    } catch (err) {
                        console.error("Error fetching stakeholder:", err);
                        showToast(t("FailedToFetchStakeholder") || "Failed to fetch stakeholder", "error");
                    }
                }
                setData({
                    isLoading: false,
                    ...response,
                    requested_by_user: user,
                });
            } catch (error) {
                console.error("Error fetching legal research request:", error);
                showToast(t("FailedToFetchLegalTranslation") || "Failed to fetch legal translation request.", "error");
                setData((prev: any) => ({ ...prev, isLoading: false }));
            }
        };

        fetchData();
    }, [id, isInternalMode, contextData.token, contextData?.user?.access_token, showToast, t]);

    if (data.isLoading)
        return (
            <div className="flex justify-center items-center h-64">
                {LoadingPageIcon}
            </div>
        );

    // Check if user is a registrar
    const isRegistrar = contextData?.user?.roles?.some((role) => role === "Registrar");
    // Check if there's a translation completion letter
    const hasTranslationCompletionLetter = data?.documents?.find((document: any) => document.document_type === "traslation_completion_letter_file");

    return (
        <>
            {isRegistrar && !hasTranslationCompletionLetter ? (
                <RegistrarLegalTranslation request={data} />
            ) : (
                <div className="flex h-full bg-gray-100 p-2">
                    <LegalAdvisoryDetail request={data} />
                    {!isRegistrar && <LegalAdvisoryRightPanel request={data} />}
                </div>
            )}
        </>
    );
};

export default SingleLegalTranslation;